module.exports = __webpack_public_path__ + "img/selfie.ace6f05b.png";